import { CodePrestation } from './../codes/code-prestation';
import { Semaine } from './semaine';

export class Agenda {
  codesPrestation: CodePrestation[] = [];

  constructor(
    public Semaines: Semaine[],
  ) { }
}
